import Model, { attr, belongsTo, type AsyncBelongsTo } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type ConversationModel from './conversation';

export const MESSAGE_STATUS = {
  COMPLETED: 'COMPLETE',
  STREAMING: 'STREAMING',
  STOPPED: 'STOPPED',
};
export default class MessageModel extends Model {
  declare [Type]: 'message';
  @attr declare created_at: string;
  @attr declare created_by: string;
  @attr('string') declare text: string;
  @attr('string') declare bot_version: string;
  @attr('string') declare type: string;

  @belongsTo('conversation', {
    async: true,
    inverse: 'messages',
  })
  declare conversation: AsyncBelongsTo<ConversationModel>;

  @attr declare loading: boolean;
  @attr('string', {
    defaultValue: MESSAGE_STATUS.COMPLETED,
  })
  declare status: string;
}
